import { useRef, useEffect, useState, memo } from "react";
import Hls from "hls.js";

const HlsVideoPlayer = ({ hlsUrl }) => {
  const videoRef = useRef(null);
  const [initialized, setInitialized] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const checkVideoExist = () => {
    const video = videoRef.current;
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(hlsUrl);
      hls.attachMedia(video);
      setInitialized(true);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = hlsUrl;
      setInitialized(true);
    }
  };

  const playVideo = () => {
    if (videoRef.current && !isVideoPlaying) {
      videoRef.current
        .play()
        .then(() => {
          setIsVideoPlaying(true);
        })
        .catch((error) => {
          console.error("Video playback error:", error);
        });
    }
  };
  useEffect(() => {
    if (!isVideoPlaying) {
      playVideo();
    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      checkVideoExist();
    }, 11000);
  }, [initialized]);

  const handleVideoError = () => {
    console.log("Video error occurred");
  };
  return (
    <>
      <video
        ref={videoRef}
        controls
        autoPlay
        playsInline
        width="100%"
        height="auto"
        onError={handleVideoError}
        muted
      />
    </>
  );
};

export default memo(HlsVideoPlayer);
